// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"SportscraftAppWrapper_bodyWrapper__ajM2_"};